import {configureStore} from "@reduxjs/toolkit";
import {setupListeners} from "@reduxjs/toolkit/query";
import createSagaMiddleware from 'redux-saga';
import rootReducer from "./reducer";
import rootSaga from "./saga";
import {apiSlice} from "~/reduxs/api/apiSlice";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(sagaMiddleware).concat(apiSlice.middleware),
});

sagaMiddleware.run(rootSaga);

// Bật refetch khi focus lại tab / reconnect mạng cho RTK Query.
setupListeners(store.dispatch);

export default store;